import axios from 'axios'
import { errorHandler } from '../exports/error_management'

const api = async (method, path, params) => axios[method](path, params)
const state = {
    selectedTemplate: {},
    templates: [],
}

const mutations = {
    set_template(state, payload) {
        state.selectedTemplate = payload
    },
    set_templates(state, payload) {
        state.templates = payload
    },
}

const actions = {
    /**
     * Set the selected template for a new template
     */
    async create(context, payload) {
        try {
            const results = await api('post', `order-template`, payload)
            context.commit('set_template', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchById(context, template_id) {
        try {
            const results = await api('get', `order-template/${template_id}`)
            console.log("results",results)
            context.commit('set_template', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAll(context) {
        try {
            const results = await api('get', `order-template`)
            context.commit('set_templates', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async update(context, payload) {
        console.log('update', payload)
        try {
            const results = await api(
                'put',
                `order-template/${payload.id}`,
                payload
            )
            context.commit('set_template', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, template_id) {
        try {
            await api('delete', `order-template/${template_id}`)
            context.commit('set_template', null)
            context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },

    async createItem(context, { template_id, item }) {
        try {
            const results = await api(
                'post',
                `order-template/${template_id}/items`,
                item
            )
            context.commit('set_template', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async updateItem(context, { template_id, item }) {
        try {
            const results = await api(
                'put',
                `order-template/${template_id}/items/${item.id}`,
                item
            )
            context.commit('set_template', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async updateItemOrder(context, payload) {
        console.log('update', payload)
        try {
             await api(
                'post',
                `order-template/update/display/order/`,
                payload
            )
            // context.commit('set_template', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async deleteItem(context, { template_id, item_id }) {
        try {
            const results = await api(
                'delete',
                `order-template/${template_id}/items/${item_id}`
            )
            context.commit('set_template', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
